import { useEffect, useState } from 'react';
import { IVoicemailsResponse } from '@/services/solgari-api/interfaces/voicemail.interface';

export const useVoicemails = () => {
  const [voicemailList] = useState<IVoicemailsResponse | null>(null);

  // const fetchVoicemails = async () => {
  //   const allVoicemails = await SolgariApiService.getVoicemailList();
  //   setVoicemailList(allVoicemails);
  // };

  useEffect(() => {
    // fetchVoicemails();
  }, []);

  return {
    voicemailList,
  };
};
